import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot, Slottable } from '../slot';
import { toggleCardFooterRecipe } from './styles/toggle-card-footer.styles';
import type { ToggleCardFooterPropsInterface } from './types/toggle-card-footer.types';

/**
 * @since 10.0.0
 */
export const ToggleCardFooter = forwardRef<HTMLDivElement, ToggleCardFooterPropsInterface>(
  (props: ToggleCardFooterPropsInterface, forwardedRef) => {
    const { asChild = false, className, children, css: cssProp, divider = true, ...rest } = props;
    const styles = css(toggleCardFooterRecipe.raw({ divider }), cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="ToggleCard.Footer"
        className={cx('c11n', 'c11n_toggle-card__footer', styles, className)}
        {...rest}
      >
        <Slottable>{children}</Slottable>
      </Component>
    );
  },
);

ToggleCardFooter.displayName = 'ToggleCard.Footer';
